import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=b4e98d10&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=ts"
export * from "./UsersManagement.vue?vue&type=script&lang=ts"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=b4e98d10&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e98d10",
  null
  
)

export default component.exports